import React from "react";
import { observer } from "mobx-react";
import { Alert, Button, Box, Typography } from "@mui/material";
import { Spinner } from "/@/app/components/Spinner";
import { formatDate } from '/@/app/utils';


export const DeleteMeasurement = observer(({ state, onDone }) => {
    const isDeleting = state.saveStatus === "saving";

    const doDelete = () => {
        state.delete();
        onDone();
    }

    if (state.value_is_computed) {
        return (
            <>
                <Alert severity="error">
                    Это вычисляемый параметр из панели! Удалить его нельзя.
                </Alert>
            </>
        );
    }

    return (
        <>
            <Typography variant="h6" component="h2">
                Удалить замер
            </Typography>

            <Typography variant="body1" component="p"
                        sx={{ textAlign: "center" }}
            >
                {state.boundParameter.name}
                <br />
                {state.value} {state.boundParameter.units}
                <br />
                от { formatDate(state.made_at) }
            </Typography>

            <Box sx={{
                mt: 2,
                display: "flex",
                flexFlow: "column nowrap",
                gap: 1,
                alignItems: "center"
            }}>
                {state.panel_id &&
                    <Alert severity="warning">
                        <b>Замер привязан к панели от {formatDate(state.made_at)}</b>!
                        При удалении, панель будет пересчитана
                        по последнему обновлению Nestarenie.Expert.
                    </Alert>
                }

                <Button
                    variant="contained"
                    color="error"
                    onClick={doDelete}
                    disabled={isDeleting}
                >
                    {isDeleting
                        ? <Spinner size={30} sx={{ color: "white" }}/>
                        : "Удалить"
                    }
                </Button>
            </Box>
        </>
    );
});
